import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoginResult } from '../../models/loginResult';
import { SnackbarService } from '../../services/snackbar.service';
import { StateService } from '../../services/state.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetPasswordComponent implements OnInit, AfterContentChecked {
  showDetails: boolean;
  passwordcriteriafail: boolean;
  resetpasswordCodeExpired: boolean;
  resetpasswordCodeError: boolean;
  code: string;
  password: string;
  resetPasswordForm: UntypedFormGroup;

  constructor(
    public stateService: StateService,
    private changeDetectorRef: ChangeDetectorRef,
    public router: Router,
    public snackBar: SnackbarService,
    public activatedRoute: ActivatedRoute,
    private cdref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.resetPasswordForm = new UntypedFormGroup({
      code: new UntypedFormControl(''),
      password: new UntypedFormControl('', [Validators.minLength(8), Validators.required]),
      confirmedPassword: new UntypedFormControl('', [Validators.minLength(8), Validators.required])
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.code = params.code;
      this.router.navigate(['/reset-password'], {
        queryParams: { code: this.code }
      });
    });
  }

  public resetPassword() {
    this.stateService
      .resetPassword(this.code, this.resetPasswordForm.controls['password'].value)
      .subscribe(
        (result: LoginResult) => {
          if (result.status === 21) {
            this.snackBar.openSnackBar(`${result.status}`, 'Doh!');
            this.changeDetectorRef.markForCheck();
          } else if (result.status === 27) {
            this.snackBar.openSnackBar(`${result.status}`, 'Doh!');
            this.changeDetectorRef.markForCheck();
          } else if (result.status === 28) {
            this.snackBar.openSnackBar(`${result.status}`, 'Doh!');
            this.changeDetectorRef.markForCheck();
          } else {
            this.snackBar.openSnackBar(`Hej igen! Ditt lösenord är nu återställt!`, 'Yay!');
            this.router.navigate(['/']);
          }
        },
        (error: LoginResult) => {
          this.snackBar.openSnackBar(`${error.status}`, 'Doh!');
          console.error(error.status);
        }
      );
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  onStrengthChanged(strength: number) {
    console.log('password strength = ', strength);
  }
}
